import { Auth0Roles as Role, RoleType } from "@/store/auth/auth.type";

export interface IRoute {
  path: string;
  displayName: string;
  roles: RoleType[];
}

export interface IRoutes {
  root: IRoute;
  restriction: IRoute;
  offstreetParking: IRoute;
  cities: IRoute;
  users: IRoute;
  clientDetail: IRoute;
  notfound: IRoute;
  error: IRoute;
  policies: IRoute;
  curbArea: IRoute;
  parkingPayment: IRoute;
  streetStatistics: IRoute;
  urbanFeature: IRoute;
  finance: IRoute;
}

export const routes: IRoutes = {
  root: {
    path: "/",
    displayName: "Home Page",
    roles: [Role.SYS_ADMIN, Role.GIS_CONTRIBUTOR],
  },
  streetStatistics: {
    path: "/street-statistics",
    displayName: "Street Statistics",
    roles: [Role.SYS_ADMIN, Role.GIS_CONTRIBUTOR],
  },
  restriction: {
    path: "/restriction",
    displayName: "Restriction",
    roles: [Role.SYS_ADMIN, Role.GIS_CONTRIBUTOR],
  },
  offstreetParking: {
    path: "/offstreet-parking",
    displayName: "Offstreet Parking",
    roles: [Role.SYS_ADMIN, Role.GIS_CONTRIBUTOR],
  },
  cities: {
    path: "/cities",
    displayName: "Cities",
    roles: [Role.SYS_ADMIN],
  },
  users: {
    path: "/users",
    displayName: "Users",
    roles: [Role.SYS_ADMIN],
  },
  clientDetail: {
    path: "/client-detail/:id",
    displayName: "Client Detail",
    roles: [Role.SYS_ADMIN],
  },
  notfound: {
    path: "/404",
    displayName: "Not found",
    roles: [],
  },
  error: {
    path: "/error",
    displayName: "Error page",
    roles: [],
  },
  policies: {
    path: "/policies",
    displayName: "Policies",
    roles: [Role.SYS_ADMIN, Role.GIS_CONTRIBUTOR],
  },
  curbArea: {
    path: "/curb-area",
    displayName: "Curb Area",
    roles: [Role.SYS_ADMIN, Role.GIS_CONTRIBUTOR],
  },
  parkingPayment: {
    path: "/parking-payment",
    displayName: "Parking Payment",
    roles: [Role.SYS_ADMIN, Role.GIS_CONTRIBUTOR],
  },
  urbanFeature: {
    path: "/urban-feature",
    displayName: "Urban Feature",
    roles: [Role.SYS_ADMIN, Role.GIS_CONTRIBUTOR],
  },
  finance: {
    path: "/finance",
    displayName: "Finance",
    roles: [Role.SYS_ADMIN, Role.GIS_CONTRIBUTOR],
  },
};
